import { render, staticRenderFns } from "./notFarmer.vue?vue&type=template&id=61f960c8&scoped=true&"
import script from "./notFarmer.vue?vue&type=script&lang=js&"
export * from "./notFarmer.vue?vue&type=script&lang=js&"
import style0 from "./notFarmer.vue?vue&type=style&index=0&id=61f960c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f960c8",
  null
  
)

export default component.exports